export interface IVisitConsentSurgeryRequest {
  proceduresRequested: string;
  lastEatDate: string;
  areVaccincationsCurrent: boolean | undefined;
  outOfDateVaccincations: string;
  isPetIll: boolean | undefined;
  hasConcernsToday: boolean | undefined;
  illnessOrConcernsNotes: string;
  isPetMicrochipped: boolean | undefined;
  microchipRequested: boolean | undefined;
  medicationsList: string;
  fleaTickMedications: string;
  hasSeriousHealthConcerns: boolean | undefined;
  hadPreviousReactions: boolean | undefined;
  needsAdditionalServices: boolean | undefined;
  additionalConcerns: string;
  infectiousDiseaseInitials: string;
  isCPRAllowed: boolean | undefined;
}

export class VisitConsentSurgeryRequest implements IVisitConsentSurgeryRequest {
  proceduresRequested: string;
  lastEatDate: string;
  areVaccincationsCurrent: boolean | undefined;
  outOfDateVaccincations: string;
  isPetIll: boolean | undefined;
  hasConcernsToday: boolean | undefined;
  illnessOrConcernsNotes: string;
  isPetMicrochipped: boolean | undefined;
  microchipRequested: boolean | undefined;
  medicationsList: string;
  fleaTickMedications: string;
  hasSeriousHealthConcerns: boolean | undefined;
  hadPreviousReactions: boolean | undefined;
  needsAdditionalServices: boolean | undefined;
  additionalConcerns: string;
  infectiousDiseaseInitials: string;
  isCPRAllowed: boolean | undefined;

  constructor(params: IVisitConsentSurgeryRequest) {
    this.proceduresRequested = _.defaultTo(params.proceduresRequested, '');
    this.lastEatDate = _.defaultTo(params.lastEatDate, '');
    this.areVaccincationsCurrent = _.defaultTo(
      params.areVaccincationsCurrent,
      undefined,
    );
    this.outOfDateVaccincations = _.defaultTo(
      params.outOfDateVaccincations,
      '',
    );
    this.isPetIll = _.defaultTo(params.isPetIll, undefined);
    this.hasConcernsToday = _.defaultTo(params.hasConcernsToday, undefined);
    this.illnessOrConcernsNotes = _.defaultTo(
      params.illnessOrConcernsNotes,
      '',
    );
    this.isPetMicrochipped = _.defaultTo(params.isPetMicrochipped, undefined);
    this.microchipRequested = _.defaultTo(params.microchipRequested, undefined);
    this.medicationsList = _.defaultTo(params.medicationsList, '');
    this.fleaTickMedications = _.defaultTo(params.fleaTickMedications, '');
    this.hasSeriousHealthConcerns = _.defaultTo(
      params.hasSeriousHealthConcerns,
      undefined,
    );
    this.hadPreviousReactions = _.defaultTo(
      params.hadPreviousReactions,
      undefined,
    );
    this.needsAdditionalServices = _.defaultTo(
      params.needsAdditionalServices,
      undefined,
    );
    this.additionalConcerns = _.defaultTo(params.additionalConcerns, '');
    this.infectiousDiseaseInitials = _.defaultTo(
      params.infectiousDiseaseInitials,
      '',
    );
    this.isCPRAllowed = _.defaultTo(params.isCPRAllowed, undefined);
  }
}
